import { FC, useContext } from "react";
import ProjectsContext from "../../contexts/data/ProjectsContext";
import { Grid, MenuItem, TextField } from "@mui/material";

interface IProjectMultiSelectProps {
    selectedProjectIds: number[],
    setSelectedProjectIds: React.Dispatch<React.SetStateAction<number[]>>,
}

const ProjectMultiSelect: FC<IProjectMultiSelectProps> = ({
    selectedProjectIds,
    setSelectedProjectIds
}) => {
    const {data: projects} = useContext(ProjectsContext);
    
    const handleProjectsChange = (event: any) => {
        setSelectedProjectIds(event.target.value);
    }

    return (
        <Grid
                size={{
                    xs: 12
                }}
            >
                <TextField
                    select
                    fullWidth
                    label="Projects"
                    value={selectedProjectIds}
                    slotProps={{
                        select: {
                            multiple: true,
                            MenuProps: {
                                sx: {
                                    maxHeight: 500
                                }
                            }
                        }
                    }}
                    onChange={handleProjectsChange}
                >
                    {
                        projects?.map(project => 
                            <MenuItem key={project.id} value={project.id}>{project.name}</MenuItem>
                        )
                    }
                </TextField>
            </Grid>
    );
}

export default ProjectMultiSelect;